import { useQuery, gql, UseQueryState } from 'urql';

const MetadataQuery = gql`
  query {
    metadata {
      amplitudeApiKey
      amplitudeDeploymentId
      friendbuyMerchantId
      googleMapsApiKey
      transferExpirationOptions
      cookieDomain
      compatibilityVersion
      region {
        country
        currency
        continent
      }
      fileSizes {
        maxWallpaperSize
        maxProfilePictureSize
        maxEmailBackgroundSize
      }
    }
  }
`;

export interface RegionData {
  country: string | null;
  continent: string | null;
  currency: string | null;
}

export interface FileSizesData {
  maxWallpaperSize: string;
  maxProfilePictureSize: string;
  maxEmailBackgroundSize: string;
}

export interface Metadata {
  transferExpirationOptions: string[];
  cookieDomain: string;
  compatibilityVersion: number;
  region: RegionData;
  fileSizes: FileSizesData;
}

export interface MetadataQueryResponse {
  metadata: Metadata;
}

type MetadataQueryVariables = Record<string, never>;

export function useMetadataQuery(): UseQueryState<
  MetadataQueryResponse,
  MetadataQueryVariables
> {
  const [result] = useQuery<MetadataQueryResponse, MetadataQueryVariables>({
    query: MetadataQuery,
  });

  return result;
}
